export default __webpack_public_path__ + "static/media/gallery_22.e2f3b726.jpg";